// PRD §3 / decision Q5 — when the right-panel form is dirty and the user
// clicks a different tree node (or a breadcrumb / mini-table row), this
// modal asks whether to discard the in-progress edit. The page store
// (`requestSelect`) parks the target node in `pendingNavigation`; confirm
// applies it, cancel clears it.

import { useTranslation } from 'react-i18next';

import { ConfirmModal } from '@/components/feedback/ConfirmModal';

import { useProItemDesignPageStore } from '../store/pro-item-design-page.store';

export function UnsavedChangesModal() {
  const { t } = useTranslation('pro-item-design');
  const pending = useProItemDesignPageStore((s) => s.pendingNavigation);
  const confirmNavigation = useProItemDesignPageStore((s) => s.confirmNavigation);
  const cancelNavigation = useProItemDesignPageStore((s) => s.cancelNavigation);

  return (
    <ConfirmModal
      open={pending !== null}
      title={t('unsavedChanges.title')}
      message={t('unsavedChanges.message')}
      confirmLabel={t('unsavedChanges.discard')}
      cancelLabel={t('unsavedChanges.stay')}
      confirmVariant="destructive"
      onConfirm={confirmNavigation}
      onCancel={cancelNavigation}
    />
  );
}
